import React from "react";
import AssetTableHeader from "../../component/DataMonitor/AssetTableHeader";
import AssetTableHead from "../../component/DataMonitor/AssetTableHead";
import AssetTableBody from "../../component/DataMonitor/AssetTableBody";

const AssetTable = ({
  tableData = [],
  loading = false,
  assetCount = 0,
  error = null,
  pagination = { page: 1, pageSize: 10, totalPages: 0, totalCount: 0 },
  onSortChange = () => { },
  onPageChange = () => { },
   onReset = () => {},
  onColumnSearchChange = () => { },
 onSearchSubmit = () => {},
   columnSearch = {},
}) => {
  const items = [
    { color: "#FB0301", label: "< 90%" },
    { color: "#FFC100", label: "90% – 95%" },
    { color: "#009F52", label: "≥ 95%" },
  ];
  const tableContainerRef = React.useRef(null);
  const [sortColumn, setSortColumn] = React.useState(null);
  const [sortOrder, setSortOrder] = React.useState("asc");

const handleResetInputs = () => {
  if (typeof onColumnSearchChange === "function") {
    Object.keys(columnSearch).forEach((col) => onColumnSearchChange(col, ""));
  }
  onReset(); 
};  

  const handleSort = (column) => {
    let newOrder = "asc";

    if (sortColumn === column && sortOrder === "asc") {
      newOrder = "desc";
    }

    setSortColumn(column);
    setSortOrder(newOrder);

    if (typeof onSortChange === "function") {
      onSortChange(column, newOrder);
    }
  };

  const renderHighlightedText = (text, searchTerm) => {
    if (!searchTerm || !text) return text;

    const parts = text.split(new RegExp(`(${searchTerm})`, "gi"));
    return parts.map((part, i) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        <span key={i} style={{ backgroundColor: "orange", fontWeight: "500" }}>
          {part}
        </span>
      ) : (
        part
      )
    );
  };

  if (error) {
    return <div className="p-4 text-red-600">Error: {error}</div>;
  }

  const totalRecords = pagination.totalCount || 0;
  const pageSize = pagination.pageSize || 10;
  const currentPage = pagination.page || 1;
  const totalPages =
    pagination.totalPages && pagination.totalPages > 0
      ? pagination.totalPages
      : Math.max(1, Math.ceil(totalRecords / pageSize));

  const gotoPage = (p) => {
    const target = Math.max(1, Math.min(totalPages, p));
    if (target !== currentPage) {
      onPageChange(target);
    }
  };

  return (
    <div className="poppins-regular">

      <AssetTableHeader
        items={items}
        totalRecords={totalRecords}
        currentPage={currentPage}
        totalPages={totalPages}
        assetCount={assetCount}
        gotoPage={gotoPage}
        handleResetInputs={handleResetInputs}
        tableContainerRef={tableContainerRef}
      />

      <div
        ref={tableContainerRef}
        style={{ overflowX: "auto", scrollBehavior: "smooth" }}
      >          <table className="min-w-full border-collapse border border-gray-200 text-sm">
          <AssetTableHead
            sortColumn={sortColumn}
            sortOrder={sortOrder}
            handleSort={handleSort}
            columnSearch={columnSearch}
            onColumnSearchChange={onColumnSearchChange}
            onSearchSubmit={onSearchSubmit} 
          />
          <AssetTableBody
            tableData={tableData}
            loading={loading}
            columnSearch={columnSearch}
            renderHighlightedText={renderHighlightedText}
          />
        </table>
      </div>
    </div>
  );
};

export default AssetTable;

